import type { DefaultChartOptions } from "./types";

const defaultChartOptions: DefaultChartOptions = {
  addDefaultPane: false,
};

export { defaultChartOptions };
